import ThisModule from "./Markdown";

export default ThisModule;
